import CompaniesTable from './companies/Table'

export default Vue => {
  Vue.component(CompaniesTable.name, CompaniesTable)
}
